import type { KeyboardEvent } from "react";

/**
 * 닫히는 중인 오버레이 내용의 키보드 활성화(Enter·Space)를 막는다.
 * 닫힘 애니메이션 동안 포커스가 남은 버튼을 키보드로 다시 눌러 콜백이 재실행되는 것을 막는 용도
 * (포인터 입력은 `.contentClosing { pointer-events: none }` 이 막는다). onKeyDownCapture·onKeyUpCapture 에 건다.
 */
export const blockActivationKeys = (e: KeyboardEvent): void => {
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    e.stopPropagation();
  }
};
